import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Table } from '../../../../../common/table'
import { FinancialStatementsValueCell } from '../../common/table/FinancialStatementsValueCell'
import { MultiTHead } from '../../common/table/MultiTHead'

import { useLocation } from 'react-router'
import { selectCompanyInfo } from '../../../../common/header/companyInfo/store/slice'
import { FilterTable } from '../../common/filterTable/FilterTable'
import { FirstColumnCell } from '../../common/table/firstColumnCell/FirstColumnCell'
import { AUDIT_STATUS, METHOD, TYPE_OF_FS } from '../../constant'
import {
  changeAuditStatus,
  changeCashFlowStatementIds,
  changeMethods,
  selectAuditStatuses,
  selectCashFlowStatementChildIds,
  selectCashFlowStatementDataRowData,
  selectCashFlowStatementIds,
  selectCashFlowStatementItem,
  selectCashFlowStatementParentId,
  selectDataYears,
  selectGroupColumns,
  selectIsLoading,
  selectIsShowCommonSize,
  selectMethods,
  selectSource,
  selectTypeOfFS,
} from '../../store/slice'
import { financialStatementsOneYearTable } from '../../store/thunk'
import classes from './CashFlowStatement.module.scss'

export const CashFlowStatement = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const cashFlowStatementIds = useSelector(selectCashFlowStatementIds)
  const groupColumns = useSelector(selectGroupColumns)
  const auditStatuses = useSelector(selectAuditStatuses)
  const methods = useSelector(selectMethods)
  const isLoading = useSelector(selectIsLoading)
  const isShowCommonSize = useSelector(selectIsShowCommonSize)
  const source = useSelector(selectSource)
  const typeOfFS = useSelector(selectTypeOfFS)
  const dataYears = useSelector(selectDataYears)

  const organizationIdParams = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  }).organizationId

  const companyInfo = useSelector(selectCompanyInfo)

  const companyType = companyInfo.companyType

  const onChangeAuditStatus = (e, year) => {
    const statusChange = auditStatuses.find((status) => status.year === year)
    const statusNotChange = auditStatuses.filter(
      (status) => status.year !== year,
    )
    const newAuditStatus = [
      ...statusNotChange,
      { year: year, isAudit: e.value === AUDIT_STATUS.audited.value },
    ]

    if (statusChange.isAudit !== (e.value === AUDIT_STATUS.audited.value)) {
      dispatch(
        financialStatementsOneYearTable({
          organizationId: Number(organizationIdParams),
          sourceOrganizationId: source.value,
          isConsolidated: typeOfFS.value === TYPE_OF_FS.consolidated.value,
          years: dataYears,
          auditStatuses: newAuditStatus,
          methods: methods,
        }),
      )
      dispatch(changeAuditStatus(newAuditStatus))
    }
  }

  const onChangeMethod = (e, year) => {
    const methodChange = methods.find((method) => method.year === year)
    const methodsNotChange = methods.filter((method) => method.year !== year)
    const newMethods = [
      ...methodsNotChange,
      { year: year, isDirect: e.value === METHOD.direct.value },
    ]

    if (methodChange.isDirect !== (e.value === METHOD.direct.value)) {
      dispatch(
        financialStatementsOneYearTable({
          organizationId: Number(organizationIdParams),
          sourceOrganizationId: source.value,
          isConsolidated: typeOfFS.value === TYPE_OF_FS.consolidated.value,
          years: dataYears,
          auditStatuses: auditStatuses,
          methods: newMethods,
        }),
      )
      dispatch(changeMethods(newMethods))
    }
  }

  return (
    <Element className={classes.container}>
      <FilterTable
        auditStatuses={auditStatuses}
        methods={methods}
        ids={cashFlowStatementIds}
      />
      <Element className={classes.tableContainer}>
        <Table
          ids={cashFlowStatementIds}
          noDataText={'common.NO_DATA'}
          getDataFromRedux={selectCashFlowStatementItem}
          isLoading={isLoading}
          isNoDataWithHead={true}
          isDisplayScroll={false}
          renderTHead={() => (
            <MultiTHead
              tableTitle={groupColumns}
              tabName={'cashFlows'}
              onChangeAuditStatus={onChangeAuditStatus}
              onChangeMethod={onChangeMethod}
            />
          )}
          schema={
            groupColumns[0]
              ? groupColumns[0].map((item, index) => {
                  const title = item.title
                  const colId = `${item.colId}`

                  const result = {
                    title,
                    colId,
                  }
                  if (index === 0) {
                    return {
                      ...result,
                      render: (val, { rowId }) => {
                        return (
                          <FirstColumnCell
                            ids={cashFlowStatementIds}
                            rowId={rowId}
                            val={val}
                            selectRowData={selectCashFlowStatementDataRowData}
                            selectChildIds={selectCashFlowStatementChildIds}
                            selectParentIds={selectCashFlowStatementParentId}
                            changeIds={changeCashFlowStatementIds}
                            tabName="cashFlows"
                          />
                        )
                      },
                    }
                  }

                  return {
                    ...result,
                    render: (val, { locale }) => {
                      return (
                        <FinancialStatementsValueCell
                          val={val}
                          locale={locale}
                          isShowCommonYoY={isShowCommonSize}
                          tabName="cashFlows"
                          companyType={companyType}
                          colId={colId}
                          isCashFlow
                        />
                      )
                    },
                  }
                })
              : []
          }
        />
      </Element>
    </Element>
  )
}
